export default "__VITE_ASSET__66e26daa__"